import { injectable, interfaces } from 'inversify';
import { action, makeObservable, observable } from 'mobx';
import { InputStatus } from '../../../../../../__legacy__/models/error.model';
import { AnnotationToolType } from '../../../../../../__legacy__/modules/annotation/submodules/annotationTypes/models/annotationToolType';
import { ProjectStatus } from '../../../../../../__legacy__/modules/projects/projects.model';
import { MarkingTool } from '../commons/models/MarkingTool';

export interface IEditMarkingToolStore {
  readonly markingToolId: string;
  readonly name: string;
  readonly nameStatus: InputStatus;
  readonly projectId: string;
  readonly projectStatus: ProjectStatus;
  readonly showModal: boolean;
  readonly toolType: AnnotationToolType;
  readonly color: string;
  readonly isUsed: boolean;
  setName(name: string): void;
  setNameStatus(nameStatus: InputStatus): void;
  setShowModal(showCreateForm: boolean): void;
  setToolType(toolType: AnnotationToolType): void;
  setColor(color: string): void;
  setMarkingTool(annotationType: MarkingTool): void;
  setProjectData(projectId: string, projectStatus: ProjectStatus): void;
  setProjectId(projectId: string): void;
  setupStore(projectId: string, markingTool: MarkingTool): void;
}

export namespace IEditMarkingToolStore {
  export const $: interfaces.ServiceIdentifier<IEditMarkingToolStore> = Symbol('EDIT_MARKING_TOOL_STORE');
}

@injectable()
export class EditMarkingToolStoreImpl implements IEditMarkingToolStore {
  markingToolId: string = '';

  name: string = '';

  nameStatus: InputStatus = InputStatus.valid();

  showModal: boolean = false;

  toolType: AnnotationToolType = AnnotationToolType.RECTANGLE;

  color: string = '';

  order: number = 0;

  isUsed: boolean = false;

  projectId: string = '';
  projectStatus: ProjectStatus = ProjectStatus.Draft;

  constructor() {
    makeObservable(this, {
      name: observable,
      nameStatus: observable,
      showModal: observable,
      toolType: observable,
      color: observable,
      order: observable,
      isUsed: observable,
      setProjectData: action,
      setMarkingTool: action,
      setupStore: action,
    });
  }

  setProjectId(projectId: string): void {
    this.projectId = projectId;
  }

  setProjectData(projectId: string, projectStatus: ProjectStatus): void {
    this.projectId = projectId;
    this.projectStatus = projectStatus;
  }

  setName(name: string): void {
    this.name = name;
  }

  setNameStatus(nameStatus: InputStatus): void {
    this.nameStatus = nameStatus;
  }

  setShowModal(showModal: boolean): void {
    this.showModal = showModal;
  }

  setToolType(toolType: AnnotationToolType): void {
    this.toolType = toolType;
  }

  setColor(color: string): void {
    this.color = color;
  }

  setMarkingTool(markingTool: MarkingTool): void {
    this.markingToolId = markingTool.id;
    this.name = markingTool.name;
    this.color = markingTool.color;
    this.order = markingTool.order;
    this.toolType = markingTool.selectorType;
    this.isUsed = markingTool.isUsed;
  }

  setupStore(projectId: string, markingTool: MarkingTool): void {
    this.setMarkingTool(markingTool);
    this.projectId = projectId;
    this.nameStatus = InputStatus.empty();
    this.showModal = true;
  }
}
